import * as Yup from 'yup'

export const productSchema = Yup.object().shape({
  name: Yup.string().nullable().max(100, 'validation-name-max').required('validation-required'),
  code: Yup.string().required('validation-required'),
  gtin: Yup.string()
    .matches(/^(?:\d{8}|\d{12}|\d{13}|\d{14})$/, 'validation-ean-gtin-regexp')
    .nullable(),
  description: Yup.string().optional().nullable(),
  product_type: Yup.string().optional().nullable(),
  image: Yup.object().shape({
    icon: Yup.string().nullable(),
  }),
  media: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().nullable(false).required('validation-required'),
      }),
    )
    .optional(),
})
